var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPStoreprofileMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_563_2046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 2.625C17.1723 2.62952 13.5027 4.15206 10.7961 6.85863C8.08954 9.56521 6.567 13.2348 6.56248 17.0625C6.5579 20.1905 7.57965 23.2336 9.47098 25.725C9.47098 25.725 9.86473 26.2434 9.92905 26.3183L21 39.375L32.0762 26.3117C32.1339 26.2421 32.529 25.725 32.529 25.725L32.5303 25.7211C34.4207 23.2307 35.442 20.189 35.4375 17.0625C35.433 13.2348 33.9104 9.56521 31.2038 6.85863C28.4973 4.15206 24.8277 2.62952 21 2.625ZM21 22.3125C19.9616 22.3125 18.9466 22.0046 18.0832 21.4277C17.2199 20.8508 16.547 20.0309 16.1496 19.0716C15.7523 18.1123 15.6483 17.0567 15.8509 16.0383C16.0534 15.0199 16.5534 14.0844 17.2877 13.3502C18.0219 12.616 18.9574 12.1159 19.9758 11.9134C20.9942 11.7108 22.0498 11.8148 23.0091 12.2121C23.9684 12.6095 24.7883 13.2824 25.3652 14.1458C25.9421 15.0091 26.25 16.0241 26.25 17.0625C26.2482 18.4544 25.6946 19.7887 24.7104 20.7729C23.7262 21.7571 22.3918 22.3108 21 22.3125Z",
    fill: "#4E26A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_563_2046",
    x: -4,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_563_2046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_563_2046",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPStoreprofileMap);
export default __webpack_public_path__ + "static/media/p_storeprofile_map.54b88c6b5b59500b6d243da7005d0f05.svg";
export { ForwardRef as ReactComponent };